module.exports = __webpack_public_path__ + "static/media/ico-upload.baaae281.svg";